








































import Vue from 'vue'
import * as _ from 'lodash'
import ExtranetHeader from './components/ExtranetHeader.vue'
import DeviceList from './components/DeviceList.vue'
import DeviceInfo from './components/DeviceInfo.vue'
import DeviceTab from './components/DeviceTab.vue'
import {
  initWebSocket,
  closeSocket,
  handleshake,
  beginDiagnosis,
  endDiagnosis,
  getComPorts,
  openSocket
} from '@/api/extranetSocketService'
import {
  diagnsisStatus,
  linkStatus,
  listenStatus,
  disconnectACKStatus,
  brokenStatus,
  pingStatus,
  errStatus,
  ExtranetLogMap,
  endExtranetStatus
} from './data'
import {
  WorkStationServiceProxy,
  WorkStationDTO,
  ExtranetServiceProxy as WorkSationExtranetServiceProxy
} from '@/service-proxies/app-v2/workStation.service-proxies'
import { ExtranetServiceProxy } from '@/service-proxies/app-v2/extranet.service-proxies'

import {
  DeviceServiceProxy
} from '@/service-proxies/app-v2/extranet.service-proxies'

const dsp = new DeviceServiceProxy()
const wssp = new WorkStationServiceProxy()
const esp = new ExtranetServiceProxy()
const wesp = new WorkSationExtranetServiceProxy()

export default Vue.extend({
  name: 'index',
  components: { ExtranetHeader, DeviceList, DeviceInfo, DeviceTab },
  data() {
    return {
      extranetSocketConfig: null, // websocket握手包信息
      extranetLogList: [], // websocket连接日志
      deviceList: [],
      currentDevice: {},
      deviceTotalCount: 0,
      departmenTreeNodes: [],
      loadDeviceStatus: false,
      deviceParam: {
        areaNameList: [],
        customerId: '',
        customerName: '',
        extranetState: '',
        current: 1,
        size: 20,
        searchKey: ''
      },
      selectNode: null,
      treeItems: {},
      isShowDiagnsis: false, // 是否显示诊断信息
      isfoldCode: true, // 是否隐藏诊断码
      newCode: '',
      expiryTimeType: 'A', // 到期类型
      expiryTime: null, // 到期时间
      configList: [], // 配置
      dataList: [], // 记录
      recordParam: {
        pageIndex: 1,
        pageSize: 10
      },
      maxPage: 0,
      selectedTab: 1,
      simpleToken: '',
      virtualLinkMsgList: [],
      spinning: false, // 全局加载中
      comPortsList: [],
      noMoreData: false,
      loadingTotal: 0,

      extranetGatewayInfo: {}
    }
  },
  created() {
    const key  = this.$route.query.key;
    if(!key){
      this.getDeviceList()
    }

    openSocket((e) => {
      this.getSocketMessage(e)
    })
    handleshake((res) => {
      // console.log('握手', res)
      this.extranetSocketConfig = res.body
    })
    getComPorts((res) => {
      // console.log('comPortsList:', res);
      this.comPortsList = res.body.result ? res.body.result : []
    })
  },
  beforeDestroy() {
    closeSocket()
  },
  watch: {
    'currentDevice.id': {
      handler(val) {
        // console.log(1111, this.currentDevice)
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    resetList(){
      this.loadingTotal=0;
      this.noMoreData=false;
      this.deviceParam.current=1;
      this.deviceParam.size=20;
      this.deviceList=[];
    },
    changeSearch(searchKey){
      this.resetList();
      this.deviceParam.searchKey = searchKey ? searchKey : ''
      this.getDeviceList();
    },
    changeTree(value) {
      this.resetList();
      this.deviceParam.areaNameList = !value.id
          ? value.key === '00-00'
              ? []
              : [value.title]
          : [value.pName] || []
      this.deviceParam.customerId = !value.id ? '' : value.id
      this.deviceParam.customerName = !value.id ? '' : value.title
      this.deviceParam.current = 1
      this.deviceList = []

      this.loadingTotal=0;
      this.noMoreData=false;

      this.getDeviceList()
    },
    changeStatus(value) {

      this.resetList();
      if (value === '3') {
        this.deviceParam.extranetState = ''
      } else {
        this.deviceParam.extranetState = value
      }
      this.deviceParam.current = 1
      this.deviceList = []
      this.getDeviceList()
    },
    // 获取设备（工位）列表
    async getDeviceList() {
      console.log('this.noMoreData:',this.noMoreData)
      if(this.noMoreData){
        return;
      }

      let paramsNew: any = {
        areaNameList: this.deviceParam.areaNameList,
        customerId: this.deviceParam.customerId,
        customerName: this.deviceParam.customerName,
        extranetState: this.deviceParam.extranetState,
        filter: this.deviceParam.searchKey,
        query: {
          current: this.deviceParam.current,
          size: this.deviceParam.size
        }
      }

      try {

        this.loadDeviceStatus = true
        const res = await dsp.findDeviceList(paramsNew)
        console.log({
          loadingTotal:this.loadingTotal
        });
        if(this.loadingTotal===res.totalCount){
          console.log(`数据已完全加载:${this.loadingTotal}`);
          this.noMoreData=true;
          return;
        }
        const maxPage = Math.ceil( res.totalCount /  this.deviceParam.size);
        this.maxPage = maxPage;

        this.deviceTotalCount = res.totalCount
        this.deviceList = this.deviceList.concat(res.list)
        this.loadingTotal+= res.list.length;

        if (this.deviceList.length) {
          // 默认选中第一个设备
          this.changeCurrentDevice(this.deviceList[0])
        }

      } catch (e) {
        this.deviceList = []
      }
      finally {
        this.loadDeviceStatus = false
      }

    },
    // 刷新列表
    loadList(data?: any) {

      let { type, searchKey } = data
      this.deviceParam.searchKey = searchKey ? searchKey : ''
      if (type && type === 'refresh') { // 刷新
        this.deviceParam.current = 1
        this.deviceList = []
      } else { // 加载更多
        if (this.deviceTotalCount > this.deviceList.length) {
          this.deviceParam.current += 1
        }
      }
      this.getDeviceList()
    },
    // 获取网关信息
    async getExtranetGateway() {
      console.log(11111111111)
      try {
        this.currentDevice = await esp.getDeviceDetail(this.currentDevice.id)
      } catch (e) {
        this.currentDevice = {}
      }
      // Object.assign(this.extranetGatewayInfo, this.currentDevice)
    },
    // 清空诊断日志
    clearLogs() {
      this.extranetLogList = []
    },
    // 切换选中的设备
    async changeCurrentDevice(data) {
      this.currentDevice = await esp.getDeviceDetail(data.id)
      // Object.assign(this.extranetGatewayInfo, this.currentDevice)
    },
    /* 改变连接状态后调用此接口刷新数据 */
    getDeviceInfo(showCode) {
      console.log('改变连接状态后调用此接口刷新数据')
      esp.getDeviceDetail(this.currentDevice.id).then(res => {
        if (res) {
          this.currentDevice = res
          this.$refs.deviceTab.isfoldCode = !showCode
          this.deviceList.map((item, index) => {
            if (item.id === this.currentDevice.id) {
              this.deviceList[index] = res
            }
          })
          this.deviceList = _.cloneDeep(this.deviceList)
        }
      })
    },
    // 得到生成诊断码接口返回的诊断码和短token，短token用于websocket开启诊断服务
    changeCode(data) {
      const { code, simpleToken } = data
      this.currentDevice.extranetCode = code
      this.simpleToken = simpleToken
    },
    // websocket: 开启本机诊断连接
    beginServer() {
      console.log('开启本机诊断连接:', this.currentDevice,this.simpleToken )
      const data = {
        extranetCode: this.currentDevice.extranetCode,
        simpleToken: this.simpleToken
      }
      if (this.extranetSocketConfig) {
        if (this.extranetSocketConfig.diagnosising === 'Working') {
          this.$confirm({
            content: '当前已有一台设备在连接中',
            okText: '确认',
            cancelText: '取消',
            onOk: () => {
              // 2.1 确认关闭原设备连接,并开启新的诊断连接
              // this.endDiagnosis('restart')
            }
          })
        } else {
          // 3.若是不是工作中，则调websocket开启连接
          this.beginDiagnosis(data)
        }
      }
    },
    beginDiagnosis(data) {
      this.spinning = true
      console.log('beginDiagnosis,data:',data);

      const noResponse = setTimeout(()=>{
        console.log('开始连接--等待响应超时');
        this.spinning=false;
        this.refreshCurrentDevice();
      }, 10*1000);

      beginDiagnosis(data, (res) => {
        console.log('开始连，回调', res);
        setTimeout(()=>{
          clearTimeout(noResponse);
          this.spinning = false;
        },500);

        if (res.body.result === 9) {
          this.$set(this.extranetSocketConfig, 'code', this.currentDevice.extranetCode)
        } else {
          // 若连接失败，弹框提示
          this.$error({
            title: '连接失败',
            content: diagnsisStatus[res.body.result]
          });
          this.refreshCurrentDevice();

        }
        // this.getDeviceInfo('showCode') // 刷新列表
      })
    },
    async refreshCurrentDevice(){
      this.currentDevice = await esp.getDeviceDetail(this.currentDevice.id);
    },
    // websocket: 断开本机诊断连接
    endDiagnosis(websocketStatus) {
      console.log('断开本机诊断连接:',this.extranetSocketConfig)
      // 1.判断websocket服务是否在工作中
      if (this.extranetSocketConfig && this.extranetSocketConfig.code) {
        endDiagnosis(res => {
          // console.log('停止诊断：', res)
          // 成功
          if (res.body.result === 1 || res.body.result === 2) {
            this.extranetSocketConfig.code = ''
            if (websocketStatus && websocketStatus === 'restart') {
              this.beginServer()
            }
          } else { // 失败
            this.$error({
              title: '断开连接失败',
              content: endExtranetStatus[res.body.result]
            })
          }
        })
      }
    },
    // websocket: 获取远程诊断相关日志的socket
    getDiagnosisLogSocket(res) {
      console.log("远程诊断相关日志:", res)
      const type = res.header.type
      let message = ''
      switch (type) {
        case 'Log.Connect.Request':
          message = `${res.body.virtualip}:${res.body.virtualport}连接请求`
          break
        case 'Log.onConnectACK.Request':
          message = res.body.virtualip + ':' + res.body.virtualport + linkStatus[res.body.result]
          break
        case 'Log.Listern.Request':
          message = `反向请求监听${res.body.port}端口`
          break
        case 'Log.onListernACK.Request':
          message = `监听${res.body.virtualport}端口结果为${listenStatus[res.body.result]}`
          break
        case 'Log.Disconnect.Request':
          message = `诊断软件${res.body.virtualip}:${res.body.virtualport}主动关闭`
          break
        case 'Log.OnDisconnectACK.Request':
          message = `诊断软件${res.body.virtualip}:${res.body.virtualport}断开连接${disconnectACKStatus[res.body.result]}`
          break
        case 'Log.OnDisconnect.Request':
          message = `接收对端指令断开连接${res.body.virtualip}:${res.body.virtualport}，断开连接诊断软件成功`
          break
        case 'Log.DisconnectACK.Request':
          message = `${res.body.virtualip}:${res.body.virtualport}断开连接成功`
          break
        case 'Log.onBroken.Request':
          message = brokenStatus[res.body.result]
          break
        case 'Log.Ping.Request':
          message = `Ping ${res.body.virtualip}中`
          break
        case 'Log.onPingACK.Request':
          message = `Ping ${res.body.virtualip + pingStatus[res.body.result]}`
          break
        case 'Log.onError.Request':
          message = errStatus[res.body.result]
          break
      }
      this.extranetLogList.unshift({
        event: ExtranetLogMap[type].title,
        message: message,
        time: res.header.timestamp
      })
      // 超过100位，末位删除
      if (this.extranetLogList.length > 100) {
        this.extranetLogList.splice(100, this.extranetLogList.length - 100)
      }
      this.extranetLogList = _.cloneDeep(this.extranetLogList)
    },
    // websocket: 获取远程连接中的广播
    getNewsLogs(res) {
      if (!res.body || !res.body.name) {
        return
      }
      const time = res.header.timestamp
      const value = res.body.value
      let message = ''
      switch (res.body.name) {
        case 'extranetServerAddress':
          this.extranetSocketConfig.extranetServerAddress = value
          break
        case 'diagnosising':
          this.extranetSocketConfig.diagnosising = value
          break
        case 'lspStatus':
          message = value === 'setupSuccess' ? '网络模块安装成功' : '网络模块安装失败'
          this.extranetLogList.unshift({ event: '网络模块安装', message: message, time: time })
          break
        case 'winSock':
          message = value === 'createSuccess' ? 'winsock创建成功' : 'winsock创建失败'
          this.extranetLogList.unshift({ event: 'winSock', message: message, time: time })
          break
        case 'lspPort':
          message = value === 'bindSuccess' ? '网络模块端口绑定成功' : '网络模块端口绑定失败'
          this.extranetLogList.unshift({ event: '网络模块端口绑定', message: message, time: time })
          break
        case 'vsDriverListernPort':
          message = value === 'listernSuccess' ? '监听成功' : '监听失败'
          this.extranetLogList.unshift({ event: '虚拟串口的通信端口监听', message: message, time: time })
          break
        case 'vsDriver':
          message = value === 'installSuccess' ? '安装成功' : (value === 'installFailed' ? '安装失败' : '安装失败（串口号已存在）')
          this.extranetLogList.unshift({ event: '虚拟串口安装', message: message, time: time })
          break
        case 'virtualLinkMsg':
          if (value.protocol === 3) {
            message = `COM${value.ip}` + (value.status === 1 ? '链路连接' : '链路断开连接')
          } else {
            message = value.ip + ':' + value.port + (value.status === 1 ? '链路连接' : '链路断开连接')
          }
          this.extranetLogList.unshift({ event: '虚拟连接', message: message, time: time })
          this.virtualLinkMsgList.push(value)
          this.configList = _.cloneDeep(this.configList)
          break
        case 'beginCode': // 收到诊断码则:1.手动把诊断码塞到握手包的返回值code里 2.刷新设备列表
          Object.assign(this.extranetSocketConfig, { code: value })
          this.getDeviceInfo('showCode')
          break
      }
      this.extranetLogList = _.cloneDeep(this.extranetLogList)
    },
    getSocketMessage(res) {
      if (res.header.type.indexOf('Log.') > -1) { // 日志
        this.getDiagnosisLogSocket(res)
      }
      if (res.header.type === 'News.Resquest') { // 广播
        this.getNewsLogs(res)
      }
    }
  }
})
